"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentStartTypeToJSON = exports.TournamentStartTypeFromJSONTyped = exports.TournamentStartTypeFromJSON = exports.TournamentStartType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TournamentStartType;
(function (TournamentStartType) {
    TournamentStartType["SHOTGUN"] = "SHOTGUN";
    TournamentStartType["TEETIME"] = "TEE_TIME";
})(TournamentStartType = exports.TournamentStartType || (exports.TournamentStartType = {}));
function TournamentStartTypeFromJSON(json) {
    return TournamentStartTypeFromJSONTyped(json, false);
}
exports.TournamentStartTypeFromJSON = TournamentStartTypeFromJSON;
function TournamentStartTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TournamentStartTypeFromJSONTyped = TournamentStartTypeFromJSONTyped;
function TournamentStartTypeToJSON(value) {
    return value;
}
exports.TournamentStartTypeToJSON = TournamentStartTypeToJSON;
